// @core/api/endpoints/project/add_item_to_epic.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddItemToEpicRequest,
  ItemResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Add item to epic
 * Associates a project item with an epic. Items can belong to only one epic at a time.
 */
export async function AddItemToEpic(
  project_id: string,
  epic_id: string,
  data: AddItemToEpicRequest,
  options?: RequestOptions
): Promise<ItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/epics/:epic_id/items`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':epic_id', encodeURIComponent(epic_id));
  const requestOptions = options;
  return client.post<ItemResponse>(requestPath, data, requestOptions);
}
